import { useEffect, useRef, useState } from "react";
import api from "../services/api";
import { getSocket } from "../services/socket-io";

// feat_407 — insignia de la Bandeja de Atención (staff de Soporte): consultas que esperan al
// equipo + respuestas automáticas sin revisar. Se monta SOLO si el superadmin tiene la feature
// `soporte` (el que llama decide). Se refresca con el evento `support` de la room del staff
// (master: `support-staff`; reseller: la de su marca — el backend elige al recibir el join).
// Socket singleton: solo `off` en el cleanup, nunca disconnect.
const useSupportStaffCounter = (enabled) => {
  const [counters, setCounters] = useState({ pending: 0, late: 0, unreviewed: 0, total: 0 });
  const timer = useRef(null);

  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    const load = () =>
      api
        .get("/superadmin/support/counters")
        .then(({ data }) => active && setCounters(data))
        .catch(() => undefined);
    load();
    const socket = getSocket();
    const join = () => socket.emit("joinSupportStaff");
    join();
    const onSupport = () => {
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(load, 1000);
    };
    socket.on("connect", join);
    socket.on("support", onSupport);
    return () => {
      active = false;
      socket.off("connect", join);
      socket.off("support", onSupport);
      if (timer.current) clearTimeout(timer.current);
    };
  }, [enabled]);

  return counters;
};

export default useSupportStaffCounter;
